// Las descargas del onboarding de marca (ADR-2026-10-05-onboarding-v2-descarga-abre-planes).
//
// Se marcan en la empresa, para medirlo. Ya no abren el catálogo de planes al salir
// (ADR-2026-10-31-descargar-no-abre-los-planes).

import { marcarDescargaDelOnboarding } from '../onboardingTracking';

let marcadaEnLaEmpresa = false;

/** Se llevó una pieza. Llamarla SÓLO si la descarga salió bien de verdad. */
export function registrarDescarga(): void {
  if (!marcadaEnLaEmpresa) {
    marcadaEnLaEmpresa = true;
    marcarDescargaDelOnboarding();
  }
}

